"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M11.854 0.146105C11.7867 0.0787708 11.7015 0.0320817 11.6085 0.0115315C11.5155 -0.00901872 11.4185 -0.00257494 11.329 0.0301046L0.329044 4.0301C0.233896 4.06472 0.1515 4.12741 0.0927566 4.20988C0.0340131 4.29235 0.00169036 4.3907 6.4496e-05 4.49194C-0.00156137 4.59318 0.0275863 4.69252 0.0836513 4.77683C0.139716 4.86115 0.220057 4.92645 0.314044 4.9641L5.11404 6.8851L7.03504 11.6851C7.0721 11.7781 7.13623 11.8579 7.21914 11.9141C7.30204 11.9702 7.3999 12.0002 7.50004 12.0001H7.50804C7.60931 11.9985 7.70771 11.9662 7.79021 11.9074C7.87271 11.8487 7.93542 11.7663 7.97004 11.6711L11.97 0.671105C12.0027 0.581635 12.0092 0.484693 11.9886 0.391686C11.9681 0.298678 11.9214 0.213476 11.854 0.146105Z",
      fill: "currentColor"
    })
  });
};

exports.default = Icon;